export default (hit, isInit) => {
  return `
    <a ${isInit ? 'js-scroll-animations-target style="opacity: 0"' : ''} href="${hit.path}" class="display-mobile fund-card fund--${hit.theme} has-halo">
      <div class="relative z-1">
        <p class="fund-card__title mb-4">${hit.title}</p>
        ${hit.description !== null && hit.description !== ''
        ? `<div class="font-secondary text-18 fund-card__txt">${hit.description}</div>`
        : ''}
      </div>

      <div class="flex relative z-1 w-full ${hit.openToSubscription ? 'justify-between' : 'justify-end'}">
        ${hit.openToSubscription
         ? `<span class="fund__subscription fund__subscription--small mr-4">
              <svg width="11" height="11" class="icon-star">
                  <use href="#icon-star" xlink:href="#icon-star" />
              </svg>
              ${config.trads['fund.open_subscription']}
          </span>`
        : ''}

        <svg width="32" height="32" class="fund-card__arrow">
          <use href="#icon-arrow" xlink:href="#icon-arrow" />
        </svg>
      </div>
    </a>
  `
}
